// useAuth-Hook: pruegft Session via /api/v1/auth/me.
//
// Bei 401 redirected die DashboardPage zu /login. Magic-Link + TOTP-Flow
// laeuft separat in LoginPage / TotpPage (TotpPage kommt mit Sprint 1.5).

import { useQuery } from "@tanstack/react-query";

import { fetchMe, MeResponse, UnauthorizedError } from "./api";

export interface AuthState {
  isLoading: boolean;
  isAuthenticated: boolean;
  totpVerified: boolean;
  /** AUFTRAG E: volle Session via Passkey (webauthn_verified-Claim). */
  webauthnVerified: boolean;
  me: MeResponse | null;
  error: Error | null;
}

export function useAuth(): AuthState {
  const q = useQuery<MeResponse, Error>({
    queryKey: ["auth", "me"],
    queryFn: fetchMe,
    retry: (failureCount, error) => !(error instanceof UnauthorizedError) && failureCount < 1,
    staleTime: 60_000,
  });

  // Volle Session = TOTP ODER Passkey (AUFTRAG E, analog require_full_session).
  const full = !!q.data && (q.data.totp_verified || q.data.webauthn_verified === true);
  return {
    isLoading: q.isLoading,
    isAuthenticated: full,
    totpVerified: !!q.data?.totp_verified,
    webauthnVerified: q.data?.webauthn_verified === true,
    me: q.data ?? null,
    error: q.error ?? null,
  };
}
